export default {
  methods: {
    // Used custom method instead of BV max-row to avoid scrollbar
    mixin_resizeTextarea(event) {
      const maxHeight = 259;
      const height = event.target.scrollHeight;

      if( height > maxHeight ) {
        event.target.style.overflow = 'auto';
        return;
      }
      event.target.style.overflow = 'hidden';
      event.target.style.height = 'auto';
      event.target.style.height = `${event.target.scrollHeight}px`;
    }
  }
};
